import { Link } from 'react-router-dom';
import * as ROUTES from "../../constants/routes";

const PartnerBar = () => {
    return (
        <div div className="w100 df jcc partnerProgramSection" >
            <div className="w90 p1rem bg1 df mt3rem mb3rem sm-fdc" style={{
                borderRadius: '40px', background: "radial-gradient(70% 70% at 24.51% 50.12%, #F5F7FF 0%, #E8ECFF 100%)"
            }}>
                <div className="w60 df fdc jcc smp1rem" style={{ paddingLeft: '60px' }}>
                    <div className='fw500 fs2rem c15' style={{ lineHeight: '35.2px' }} >
                        Partner Program
                    </div>
                    <div className="fw400 fs1rem c14 mt1rem" style={{ lineHeight: '32px', letterSpacing: '5.5%' }}>
                        {/* Do you have a service for our Diligentsia <span className='c4'>AppStore</span>? <br></br>Want to co-brand a module? */}
                        Do you offer a specialist professional service?  Want to co-brand a module for our Diligentsia App<span className='c4'>Store</span>?
                    </div>
                    <div>
                        <Link className="w40 bg4 df jcc br40px fw600 fs1rem c1 mt2-5rem py0-5rem" style={{ lineHeight: '30px' }} to={ROUTES.PARTNER_PROGRAM}>
                            See Details
                        </Link>
                    </div>
                </div>
                <div className='w40 pr df aic jcc'>
                    <img src={require('../../../images/partnerProgramPricingPage.png')} className='w50 cp' alt='img'
                        onClick={() => window.open('https://koalendar.com/e/meet-with-mark-bernstein-koaSc6kO?embed=true', '_blank')}
                    />
                </div>
            </div>
        </div>
    )
}

export default PartnerBar